<!-- TODO: Modify Logo Switching -->
<img *ngIf="!darkMode" class="w-auto cursor-pointer" src="assets/images/brand/logos/hagile-logo-light.svg" alt="hagile-logo">
<img *ngIf="darkMode" class="w-auto cursor-pointer" src="assets/images/brand/logos/hagile-logo-dark.svg" alt="hagile-logo-dark">